import { UserConstants } from '../constants';
import { authService, userService } from '../services';
import {history} from '../helpers';
export const UserActions = {
    login,
    logout,
    create_driver,
    get_drivers,
    create_certificate,
    get_ucertificates,
    get_ucertificate,
    confirm_certificate,
    get_certificates_bydriver,
    get_drivers_bycertificate,
    delete_certificate
}; 

function get_drivers() {
    return dispatch => {
        dispatch(request({}));
        let userToken = localStorage.getItem('userToken');
        userService.get_drivers(userToken)
            .then(
                drivers => {
                    dispatch(success(drivers));
                }
            )
            .catch(
                error => {
                    if(error.response && error.response.data){
                        dispatch(failure(error.response.data));
                    }
                    else dispatch(failure(error));
                }
            );
        
        function success(drivers) { return { type: UserConstants.DRIVERS_SUCCESS, payload: drivers };}
        function request(drivers) { return { type: UserConstants.DRIVERS_REQUEST, payload: drivers };}
        function failure(message) { return { type: UserConstants.DRIVERS_ERROR, payload: message };}
    };
}

function get_ucertificates() {
    return dispatch => {
        dispatch(request({}));
        let userToken = localStorage.getItem('userToken');
        userService.get_ucertificates(userToken)
            .then(
                certificates => {    
                    dispatch(success(certificates));
                }
            )
            .catch(
                error => {
                    if (error.response && error.response.data) {
                        dispatch(failure(error.response.data));
                    }
                    else dispatch(failure(error));
                }
            );

        function success(certificates) {return {type: UserConstants.UNCONFIRMED_SUCCESS, payload: certificates};}
        function request(certificates) {return {type: UserConstants.UNCONFIRMED_REQUEST, payload: certificates };}
        function failure(message) { return { type: UserConstants.UNCONFIRMED_ERROR, payload: message };}
    };
}

function create_certificate(certificate) {
    return dispatch => {
        dispatch(request());
        let userToken = localStorage.getItem('userToken');
        userService.create_certificate(certificate, userToken)
            .then(
                response => {dispatch(success(response));}
            )
            .catch(
                error => {
                    if (error.response && error.response.data) {
                        dispatch(failure(error.response.data));
                    }
                    else dispatch(failure(error));
                }
            );
    };

    function success(response) {return {type: UserConstants.CERTIFICATE_SUCCESS, payload:response};}
    function request() {return {type: UserConstants.CERTIFICATE_REQUEST};}
    function failure(message) {return { type: UserConstants.CERTIFICATE_ERROR, payload: message};}
}

function create_driver(driver){
    return dispatch =>{
        dispatch(request());
        let token = localStorage.getItem('userToken');
        userService.create_driver(driver,token)
            .then(
                response => { dispatch(success(response));}
            )
            .catch(
                error => {
                    if(error.response.data){
                        dispatch(failure(error.response.data));
                    }
                    else dispatch(failure(error));
                }
            );
    };

    function success(response) {return {type: UserConstants.DRIVER_SUCCESS, payload: response};}
    function request() {return {type: UserConstants.DRIVER_REQUEST};}
    function failure(message) {return { type: UserConstants.DRIVER_ERROR, payload: message};}
}


function login(username, password) {
    return dispatch => {
        dispatch(request({ username }));
        authService.login(username, password)
            .then(
                user => {
                    localStorage.setItem('userToken', user.data.token );
                    localStorage.setItem('userType', user.data.user_type );
                    user.name = username;
                    dispatch(success(user));
                    history.push('/');
            
                },
                error => {
                    dispatch(failure(error));
                } 
            );   
    };

    function request(user) {return {type: UserConstants.LOGIN_REQUEST, payload: user};}
    function success(user) {return {type: UserConstants.LOGIN_SUCCESS, payload: user};}
    function failure(error) {return {type: UserConstants.LOGIN_FAILURE, payload: error};}
        
}
function get_ucertificate(driverId, certificate){
    return dispatch => {
        dispatch(request());

        let userToken = localStorage.getItem('userToken');
        userService.getucertificates_driver(driverId, certificate, userToken)
            .then(
                ucDetails => {
                    dispatch(success(ucDetails));
                }   
            )
            .catch(
                error => {
                    if (error.response) {
                        dispatch(failure(error.response.data));
                    }
                    else dispatch(failure(error));
                }
            ); 
    };

    function request() {return {type: UserConstants.UCDETAILS_REQUEST};}
    function success(ucDetails) {return { type: UserConstants.UCDETAILS_SUCCESS, payload: ucDetails };}
    function failure(error) { return { type: UserConstants.UCDETAILS_ERROR, payload: error };}

}

function get_certificates_bydriver(driverId){
    return dispatch => {
        dispatch(request());
        let userToken = localStorage.getItem('userToken');
        userService.get_certificates_bd(userToken, driverId)
            .then(
                certificatesbd => {
                    dispatch(success(certificatesbd));
                }
            )
            .catch(
                error => {
                    if (error.response) {
                        dispatch(failure(error.response.data));
                    }
                    else dispatch(failure(error));
                }
            );
    };

    function request() { return { type: UserConstants.CERTIFICATESBD_REQUEST };}
    function success(certificatesbd) { return { type: UserConstants.CERTIFICATESBD_SUCCESS, payload: certificatesbd };}
    function failure(error) { return { type: UserConstants.CERTIFICATESBD_ERROR, payload: error };}
}
function get_drivers_bycertificate(certificate) {
    return dispatch => {
        dispatch(request());
        let userToken = localStorage.getItem('userToken');
        userService.get_drivers_bc(userToken,certificate)
            .then(
                driversbc=>{
                    dispatch(success(driversbc));
                }
            )
            .catch(
                error => {
                    if (error.response) {
                        dispatch(failure(error.response.data));
                    }
                    else dispatch(failure(error));
                }
            );
    };

    function request() { return { type: UserConstants.DRIVERSBC_REQUEST };}
    function success(driversbc) { return { type: UserConstants.DRIVERSBC_SUCCESS, payload: driversbc };}
    function failure(error) { return { type: UserConstants.DRIVERSBC_ERROR, payload: error };}
}


function confirm_certificate(driverId, certificate, i) {
    let userToken = localStorage.getItem('userToken');
    userService.confirm_certificate(driverId, certificate, userToken);   
    return { type: UserConstants.CONFIRM_CERTIFICATE, payload:  i };
}

function logout() {
    authService.logout();
    return { type: UserConstants.LOGOUT };
}

function delete_certificate(driverId, certificate, i){
    let userToken = localStorage.getItem('userToken');
    userService.delete_certificate(userToken, driverId, certificate);
    return {type: UserConstants.DELETE_CERTIFICATE, payload: i};
}


// WEBPACK FOOTER //
// ./src/actions/UserActions.js